import React from 'react';
import './CurrencyDisplay.css';

interface CurrencyDisplayProps {
    amount: number;
}

const CurrencyDisplay: React.FC<CurrencyDisplayProps> = ({ amount }) => {
    if (typeof amount !== 'number' || isNaN(amount)) {
        return <div className="currency-display">Invalid amount</div>;
    }

    let fullAmount;
    let decimal;

    if (Number.isInteger(amount)) {
        fullAmount = amount.toString();
        decimal = '00';
    } else {
        const amountString = amount.toFixed(2);
        [fullAmount, decimal] = amountString.split('.');
    }

    return (
        <div className="currency-display">
            <span className="currency-display__symbol">€</span>
            <span className="currency-display__whole">{fullAmount}</span>
            <span className="currency-display__separator">,</span>
            <span className="currency-display__decimal">{decimal}</span>
        </div>
    );
};

export default CurrencyDisplay;
